<script>
export default {
    name: 'FlagSpain',
}
</script>
<template>
    <svg
        class="base-flag flag-spain"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="28"
        height="20"
        viewBox="0 0 28 20"
    >
        <defs><path id="a" d="M0 0h28v20H0z" /></defs>
        <g fill="none" fill-rule="evenodd">
            <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
            <use fill="#FFF" xlink:href="#a" />
            <path
                fill="#DD172C"
                d="M0 0h28v5.333H0zm0 14.667h28V20H0z"
                mask="url(#b)"
            />
            <path fill="#FFD133" d="M0 5.333h28v9.333H0z" mask="url(#b)" />
            <path
                fill="#FFEDB1"
                d="M7.333 9.333h1.334V10H7.333z"
                mask="url(#b)"
            />
            <path
                stroke="#A41517"
                stroke-width=".667"
                d="M8.36 9.002l-2.283.579.144 1.726c.024.288.164.545.383.728.218.182.513.29.849.292.258-.03.493-.153.67-.333a1.11 1.11 0 00.321-.675l-.083-2.317z"
                mask="url(#b)"
            />
            <path
                fill="#A41517"
                d="M6 10h2.667v.667H8L7.333 12l-.666-1.333H6zM4 8h1.333v4.667H4zm5.333 0h1.333v4.667H9.333zM6 7.333c0-.368.306-.666.673-.666h1.32c.372 0 .674.296.674.666v.33A.33.33 0 018.34 8H6.327A.327.327 0 016 7.664v-.33z"
                mask="url(#b)"
            />
        </g>
    </svg>
</template>
